import { BOOT_FS_TIMEOUT_MS, isTimeoutError, withTimeout } from './withTimeout'

/** Copy shown when users/{uid} getDoc fails or times out. */
export const PROFILE_CONNECTION_ERROR =
  'Could not load your account profile. Check your connection and try again.'

export function isProfileConnectionError(message: string | null | undefined): boolean {
  return message === PROFILE_CONNECTION_ERROR
}

export function authProfileLoadErrorMessage(err: unknown): string {
  const msg = err instanceof Error ? err.message : String(err)
  if (isTimeoutError(err)) return PROFILE_CONNECTION_ERROR
  return (
    'Could not load your account profile from Firestore. ' +
    (msg.includes('permission') || msg.includes('Permission')
      ? 'Permission denied — check Firestore rules on this Firebase project.'
      : 'Check your connection and that this build points at the correct Firebase project.') +
    (msg ? ` (${msg})` : '')
  )
}

/** Boot-capped getDoc. The underlying read is not cancelled on timeout. */
export function getDocWithBootTimeout<T>(promise: Promise<T>, label: string): Promise<T> {
  return withTimeout(promise, BOOT_FS_TIMEOUT_MS, label)
}
